const Home = () => import(/* webpackChunkName: "Home" */ './components/home');
const products = () => import(/* webpackChunkName: "products" */ './components/products');
const allergens2 = () => import(/* webpackChunkName: "allergens2" */ './components/allergens2');
const CookiePolicy = () => import(/* webpackChunkName: "CookiePolicy" */ './components/CookiePolicy');

const routes = [
  {
    path: '/:lang?',
    name: 'home',
    component: Home
  },
  {
    path: '/:lang?/cookies',
    name: 'cookies',
    component: CookiePolicy
  },
  {
    path: '/:lang?/products/:id?',
    name: 'products',
    component: products,
    props: { allergenShow: false }
  },
  {
    path: '/:lang?/allergens/:id?',
    name: 'allergens',
    component: allergens2
  }
]

export default routes;
